import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import UserConsultationTab from "../Components/UserConsultationTab";
import { doctorimg } from "../Constant/Index";

const UserMyConsultations = () => {
	return (
		<>
			<Header />
			<PageHeader pagename="User Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<UserProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	 mb-3">
									<div class="edit-btn back">
										<Link to="/">
											<div class="nav-anchor">
												<i class="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<div className="d-flex align-items-center  justify-content-between w-100">
										<h5 class="main-heading level-6 ps-3 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
											My Consultations
										</h5>
										<UserConsultationTab />
									</div>
								</div>
								<div className="row">
									<div className="col-lg-6">
										<div className="doctor-detail-des main-profile-content radius-20 p-4">
											<div className="d-flex align-items-center gap-3 mb-2">
												<img src={doctorimg} className="img-fluid" alt="" />
												<div>
													<h4 className="main-heading-font dark-color mb-0">
														Jennifer Aniston
													</h4>
													<h5 className="mb-0 extra-color-9">
														General Physician
													</h5>
												</div>
											</div>
											<div className="mt-4">
												<Link
													className="detail-physician-btn"
													to="/consultation-detail"
												>
													<span>
														<i class="fa-regular fa-calendar"></i>{" "}
													</span>
													Sun - May 10, 1:00pm - 2:00pm
												</Link>
											</div>
										</div>
									</div>
									<div className="col-lg-6">
										<div className="doctor-detail-des main-profile-content radius-20 p-4">
											<div className="d-flex align-items-center gap-3 mb-2">
												<img src={doctorimg} className="img-fluid" alt="" />
												<div>
													<h4 className="main-heading-font dark-color mb-0">
														Jennifer Aniston
													</h4>
													<h5 className="mb-0 extra-color-9">
														General Physician
													</h5>
												</div>
											</div>
											<div className="mt-4">
												<Link className="detail-physician-btn" to="">
													<span>
														<i class="fa-regular fa-calendar"></i>{" "}
													</span>
													Sun - May 10, 1:00pm - 2:00pm
												</Link>
											</div>
										</div>
									</div>
									<div className="col-lg-6 mt-4">
										<div className="doctor-detail-des main-profile-content radius-20 p-4">
											<div className="d-flex align-items-center gap-3 mb-2">
												<img src={doctorimg} className="img-fluid" alt="" />
												<div>
													<h4 className="main-heading-font dark-color mb-0">
														Jennifer Aniston
													</h4>
													<h5 className="mb-0 extra-color-9">
														General Physician
													</h5>
												</div>
											</div>
											<div className="mt-4">
												<Link className="detail-physician-btn" to="">
													<span>
														<i class="fa-regular fa-calendar"></i>{" "}
													</span>
													Sun - May 10, 1:00pm - 2:00pm
												</Link>
											</div>
										</div>
									</div>
									<div className="col-lg-6 mt-4">
										<div className="doctor-detail-des main-profile-content radius-20 p-4">
											<div className="d-flex align-items-center gap-3 mb-2">
												<img src={doctorimg} className="img-fluid" alt="" />
												<div>
													<h4 className="main-heading-font dark-color mb-0">
														Jennifer Aniston
													</h4>
													<h5 className="mb-0 extra-color-9">
														General Physician
													</h5>
												</div>
											</div>
											<div className="mt-4">
												<Link className="detail-physician-btn" to="">
													<span>
														<i class="fa-regular fa-calendar"></i>{" "}
													</span>
													Sun - May 10, 1:00pm - 2:00pm
												</Link>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default UserMyConsultations;
